<template>
  <div>
    <page-header title="Usuários Admin Quero Pago">
      <template #description>
        Lista de usuários administradores e seus papéis (roles).
        Busque por nome ou e-mail e atualize o role de cada um pra
        controlar o acesso aos módulos do admin.
      </template>
    </page-header>

    <div class="row">
      <div class="col-md-9">
        <div class="input-group input-group-lg search-student-field">
          <input v-model="search" type="text" class="form-control"
                 ref="searchInput" placeholder="Pesquisar usuário por nome ou email"
                 @keyup.enter="searchUsers"
          >
          <span class="input-group-btn">
            <button class="btn btn-primary" type="button" @click="searchUsers">Pesquisar</button>
          </span>
        </div>
      </div>
    </div>

    <div class="users-list">
      <div class="list-group-item"
           :to="{ name: 'user-details', params: { id: user.id } }"
           v-for="user in users" :key="user.id"
      >
        <div class="user">
          <div class="user-name">
            <strong>{{ user.name }}</strong>
          </div>
          <div class="user-email">
            {{ user.email }}
          </div>
        </div>

        <div class="btns">
          <div class="btns-view">
            <button
              class="btn btn-info"
              title="Visualizar"
              @click.prevent="handleUsersRolesModal('view', 'open', user)"
            >
              <i class="fas fa-eye"></i>
            </button>
          </div>
          <div class="btns-edit">
            <button
              class="btn btn-primary brg__button-margin--left"
              title="Editar"
              @click.prevent="handleUsersRolesModal('update', 'open', user)"
            >
              <i class="fas fa-edit"></i>
            </button>
          </div>
        </div>
      </div>

      <div v-if="totalPages" class="pagination">
        <pagination ref="pagination" :total-pages="totalPages" @page-changed="onPageChange" />
      </div>

      <div v-if="users.length === 0">
        Nenhum usuário encontrado
      </div>

      <view-user-roles-modal
        :user="selectedUser"
        @close="handleUsersRolesModal('view', 'close')"
        v-if="showViewUserRolesModal"
      />


      <update-user-roles-modal
        :user="selectedUser"
        @close="handleUsersRolesModal('update', 'close')"
        v-if="showUpdateUserRolesModal"
      />
    </div>
  </div>
</template>

<script>
import AdminUsersService from 'services/AdminUsersService';
import Pagination from 'components/Pagination';
import UpdateUserRolesModal from './components/UpdateUserRolesModal';
import ViewUserRolesModal from './components/ViewUserRolesModal';

export default {
  data() {
    return {
      users: [],
      page: 1,
      totalPages: null,
      search: this.$route.query.search || '',
      selectedUser: null,
      showUpdateUserRolesModal: false,
      showViewUserRolesModal: false,
    };
  },
  mounted() {
    this.loadUsers();
    this.$refs.searchInput.focus();
  },
  components: {
    Pagination,
    UpdateUserRolesModal,
    ViewUserRolesModal,
  },
  methods: {
    onPageChange(page) {
      this.page = page;
      this.loadUsers();
    },

    searchUsers() {
      this.page = 1;
      this.totalPages = null;
      this.loadUsers();
    },

    loadUsers() {
      this.$loader.show();
      AdminUsersService.getAll(this.search, this.page).then((response) => {
        this.users = response.users;
        this.totalPages = response.total_pages;
        this.$loader.hide();
      })
        .catch((error) => {
          this.$loader.hide();
          this.$alert.notifyAlert(error.response?.data?.message || 'Erro ao carregar usuários.');
        });
    },

    handleUsersRolesModal(type, action, user = null) {
      this.selectedUser = user;

      switch (type) {
        case 'update':
          this.showUpdateUserRolesModal = (action === 'open');
          break;
        case 'view':
          this.showViewUserRolesModal = (action === 'open');
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
  .btns {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 50%;
  }

  .btns-edit {
    padding-left: 10px;
  }

  .list-group-item {
    display: flex;
    flex-direction: row;
  }

  .pagination {
    gap: 10%;
  }

  .search-student-field {
    z-index: 0;
  }

  .user {
    width: 50%;
  }

  .users-list{
    margin-top: 2%;
  }
</style>
